import { render, staticRenderFns } from "./BulkUploadCourse.vue?vue&type=template&id=19e053ff&"
import script from "./BulkUploadCourse.vue?vue&type=script&lang=js&"
export * from "./BulkUploadCourse.vue?vue&type=script&lang=js&"
import style0 from "./BulkUploadCourse.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports